import React from 'react';

const InovasiIoTAIEraDigital: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Perkembangan teknologi komputasi telah memasuki babak baru di mana batas antara dunia fisik dan dunia digital semakin menyatu. Konvergensi antara perangkat keras <b>Internet of Things (IoT)</b> dan kecerdasan buatan (<b>Artificial Intelligence / AI</b>)—yang sering disebut sebagai <i>AIoT</i>—telah membuka cakrawala baru bagi terciptanya solusi otomasi cerdas yang responsif terhadap kondisi lingkungan secara <i>real-time</i>.
      </p>

      <p className="mb-4">
        Dalam kategori <b>Innovative Technology Challenge (ITC)</b> pada perhelatan <i>Indonesia Innovative Technology (IIT) Challenge</i>, para inovator muda dari berbagai jenjang pendidikan unjuk kebolehan merancang prototipe perangkat keras dan perangkat lunak terintegrasi yang dirancang khusus untuk memecahkan permasalahan krusial di sektor pertanian, lingkungan hidup, kesehatan, dan industri perkotaan.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Arsitektur Proyek: Dari Sensor Fisik ke Analisis Cloud
      </h2>
      <p className="mb-4">
        Sebagian besar karya inovasi yang dipamerkan memanfaatkan mikrokontroler hemat daya berkinerja tinggi seperti ESP32, Raspberry Pi, dan Arduino yang dilengkapi modul komunikasi nirkabel. Data fisik dari lingkungan sekitar ditangkap oleh berbagai sensor:
      </p>

      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Sensor Kualitas Tanah dan Kelembaban (Soil Moisture):</strong> Mengukur kadar air dan pH tanah untuk mengoptimalkan siklus irigasi pertanian pintar (<i>Smart Agriculture</i>).
        </li>
        <li>
          <strong>Sensor Kualitas Udara (MQ Series & PM2.5):</strong> Mendeteksi konsentrasi gas berbahaya, polusi asap, dan partikel debu mikro di area pemukiman.
        </li>
        <li>
          <strong>Kamera Miniatur Berbasis Edge AI (ESP32-CAM):</strong> Memproses klasifikasi jenis sampah otomatis atau deteksi objek secara lokal di perangkat tanpa memerlukan server cloud berbiaya tinggi.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Mendorong Semangat Riset dan Terapan
      </h2>
      <p className="mb-4">
        Ajang <i>Innovative Technology Challenge</i> membuktikan bahwa generasi muda Indonesia memiliki kapasitas intelektual dan kreativitas teknik yang luar biasa. Melalui bimbingan yang tepat dan fasilitas pengujian prototipe yang memadai, karya-karya inovasi ini berpotensi besar untuk dihilirisasi menjadi produk nyata yang berdaya saing di kancah nasional maupun internasional.
      </p>
    </div>
  );
};

export default InovasiIoTAIEraDigital;
